import React, { useState, useEffect, useMemo } from "react";
import { useAccountStore } from "../../../hooks/admin/account";
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import { AgGridReact } from 'ag-grid-react';
import useReduxState from 'src/hooks/useReduxState';
import NoResultContent from '../../HomePageContent/NoResultContent';
import { __remove, __set } from 'src/store/axios_indicator';
import Constants from 'src/helper/Constants';
import Helper from 'src/helper/Helper';
import Admin from "@system/config/admin";
import { useAdminCommonStore } from '../../../hooks/admin/adminCommon';
import { Tooltip } from 'src/component/Global/Tooltip';
import { useUserStore } from 'src/hooks/admin/user';
import RoleSelection from '../AdminModals/RoleSelection';
import System from 'src/helper/system';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';

var roleData = [];
var isEditGlobal = false;

export function SponsorAccountList(props) {
  const [__check] = useAxiosIndicatorCheck();
  const [{ accountUserList, totalAccountUser }, { get_account_user_list, export_account_user_list }, { }] = useAccountStore();
  const [selectionCount, setSelectionCount] = useState(0);
  const [refreshGrid, setRefreshGrid] = useReduxState(false, 'setRefreshGrid');
  const [isEdit] = useReduxState(false, 'setIsEdit');
  const [rowData, setRowData] = useState([]);
  const gridRef = React.useRef();
  const userId = props.userId;
  const [gridColumnApi, setGridColumnApi] = useState(null);
  const [agGridFiltered, setAgGridFiltered] = useState(0);
  const [{ accountDetail }] = useAccountStore();
  const [{ roleList }] = useAdminCommonStore();
  const [{ selectedRoles }, { }, { set_role_selection_popup_status, set_select_user_sponsor_accounts, update_user_roles }] = useUserStore();
  const [selectedIndex, setIndex] = useState(-1);
  const [{ }, { system_alert_indicator }, { }] = useDOMAttachToSystemStore();

  useEffect(() => {
    async function fetchHere() {
      await fetchAPICall();
    }

    fetchHere();
  }, []);

  const isRowSelectable = useMemo(() => {
    return (params) => {
      return (params.data && params.data.Source !== 'SAP');
    };
  }, []);

  useEffect(() => {
    async function fetchHere() {
      setSelectionCount(0);
      await fetchAPICall();
      setRefreshGrid(false);
    }
    if (refreshGrid) {
      fetchHere();
    }
  }, [refreshGrid]);


  useEffect(() => {
    const _userList = accountUserList?.map((ele) => {
      return {
        AccountName: accountDetail.account_name,
        AccountNumber: accountDetail.account_number,
        AccountStatus: accountDetail.active ? 'Active' : 'Inactive',
        AccountCreatedOn: accountDetail.createdDate ? Helper.getDatepickerFormatAdminConsole(accountDetail.createdDate) : "",
        AccountUpdatedOn: accountDetail.updatedDate ? Helper.getDatepickerFormatAdminConsole(accountDetail.updatedDate) : "",
        SalesOrg: accountDetail.sales_org,
        Description: accountDetail.description,
        Currency: accountDetail.currency,
        Payment: accountDetail.payment_term_id,
        BillToCountry: accountDetail.bill_to_country_code,
        Sdi: accountDetail.sdi_number,
        CreditRisk: accountDetail.creditRisk === true ? 'Yes' : accountDetail.creditRisk === false ? 'No' : '',
        OrderBlock: accountDetail.orderBlock === true ? 'Yes' : accountDetail.orderBlock === false ? 'No' : '',
        Role: ele.role ? ele.role.split(',').map(v => v.trim()) : [],
        Email: ele.email,
        FirstName: ele.firstName,
        LastName: ele.lastName,
        TelephoneNumber: ele.telephone_Number,
        MobileNumber: ele.mobile_Number,
        Source: ele.source,
        Status: ele.status ? 'Active' : 'Inactive',
        CreatedOn: ele.createdOn ? Helper.getDatepickerFormatAdminConsole(ele.createdOn) : "",
        UserId: ele.user_id,
        UserType: ele.userType
      }
    });
    setRowData(_userList)
  }, [accountUserList, accountDetail]);

  const loadUserId = (e) => {
    return <>
      <a href={Admin.getUserDetailURL() + '?uid=' + (e?.data?.UserId ? e?.data?.UserId : e.node.allLeafChildren[0].data.UserId) + '&userType=' + e?.data?.UserType} className='' target="_blank" rel="noreferrer"> {e.value}</a>
    </>
  }

  const openPopup = (account, rowIndex) => {
    setIndex(rowIndex)
    set_select_user_sponsor_accounts({ account, userData: { userName: Helper.valueIsNotNull(account.UserName) ? account.UserName : (account?.FirstName + ' ' + account?.LastName) } })
    set_role_selection_popup_status(true);
  };

  useEffect(() => {
    roleData = roleList;
  }, [roleList])

  const addRole = (e) => {
    let data;
    if (e.data) {
      data = e.data;
    } else if (e.node.field === 'Role') {
      data = e.node.allLeafChildren[0]?.data;
    } else return "";
    const role = data.Role;
    let renderedRole = Helper.renderRoles(role, roleData);
    const cellContent = (data.Source === "SAP" || isEditGlobal) ? <span className={'text-black-stone'}>{role.length > 0 ? renderedRole : 'Select a Role (required)'}</span> :
      <a className={'text-blue2'} onClick={() => {
        openPopup(e.data, e.rowIndex)
      }}><u>
          {role.length > 0 ? renderedRole : 'Select a Role (required)'}
        </u>
      </a>

    return role.length > 0 ? <Tooltip
      arrow={false}
      position={'top left'}
      opener={() => cellContent}
      content={() => `${renderedRole}`}
    /> : cellContent;
  }

  const roleSortingAgGrid = (roleA, roleB) => {
    const renderedRoleA = Helper.renderRoles(roleA, roleData);
    const renderedRoleB = Helper.renderRoles(roleB, roleData);
    return renderedRoleA.localeCompare(renderedRoleB);
  }

  // eslint-disable-next-line no-unused-vars
  const [columnDefs, setColumnDefs] = useState([
    { field: 'AccountName', hide: true, headerName: 'ACCOUNT NAME', unSortIcon: true },
    { field: 'AccountNumber', hide: true, headerName: 'ACCOUNT NUMBER', unSortIcon: true},
    { field: 'AccountStatus', hide: true, headerName: 'ACCOUNT STATUS', unSortIcon: true},
    { field: 'AccountCreatedOn', hide: true, headerName: 'ACCOUNT CREATED ON', unSortIcon: true},
    { field: 'AccountUpdatedOn', hide: true, headerName: 'ACCOUNT UPDATED ON', unSortIcon: true},
    { field: 'SalesOrg', hide: true, headerName: 'SALES ORG', unSortIcon: true},
    { field: 'Description', hide: true, headerName: 'DESCRIPTION', unSortIcon: true},
    { field: 'Currency', hide: true, headerName: 'CURRENCY', unSortIcon: true},
    { field: 'Payment', hide: true, headerName: 'PAYMENT TERM ID', unSortIcon: true},
    { field: 'BillToCountry', hide: true, headerName: 'BILL TO COUNTRY', unSortIcon: true},
    { field: 'Sdi', hide: true, headerName: 'SDI', unSortIcon: true},
    { field: 'CreditRisk', hide: true, headerName: 'CREDIT RISK', unSortIcon: true},
    { field: 'OrderBlock', hide: true, headerName: 'ORDER BLOCK', unSortIcon: true},
    {
      field: '', pinned: 'left', lockPosition: "left",
      headerCheckboxSelection: true,
      checkboxSelection: true,
      showDisabledCheckboxes: true,
      width: 50,
      enableFilter: false,
      unSortIcon: true
    },
    {
      field: 'Email', pinned: 'left', minWidth: 150, lockPosition: "left",
      width: 50,
      enableFilter: false,
      suppressMovable: true,
      headerName: 'EMAIL',
      headerTooltip: 'EMAIL',
      sortable: true, comparator: Helper.textSortingAgGrid,
      cellRenderer: loadUserId,
      unSortIcon: true
    },
    {
      field: 'FirstName', pinned: 'left', minWidth: 200, suppressMovable: true, lockPosition: "left",
      headerName: 'FIRST NAME',
      headerTooltip: 'FIRST NAME',
      sortable: true, comparator: Helper.textSortingAgGrid,
      unSortIcon: true
    },

    { field: 'LastName', pinned: 'left', headerName: 'LAST NAME', lockPosition: "left", headerTooltip: 'LAST NAME', sortable: true, comparator: Helper.textSortingAgGrid,unSortIcon: true },
    {
      field: 'Role',
      minWidth: 130, headerName: 'ROLE', headerTooltip: 'ROLE', sortable: true,
      comparator: roleSortingAgGrid,
      cellRenderer: addRole,
      unSortIcon: true

    },
    { field: 'TelephoneNumber', minWidth: 130, headerName: 'TELEPHONE NUMBER', headerTooltip: 'TELEPHONE NUMBER', sortable: true, comparator: Helper.textSortingAgGrid, cellClass: 'stringType',unSortIcon: true },
    { field: 'MobileNumber', minWidth: 130, headerName: 'MOBILE NUMBER', headerTooltip: 'MOBILE NUMBER', sortable: true, comparator: Helper.textSortingAgGrid, cellClass: 'stringType',unSortIcon: true },
    {
      field: 'CreatedOn',
      minWidth: 130,
      headerName: 'CREATED ON',
      headerTooltip: 'CREATED ON',
      sortable: true,
      comparator: Helper.dateSortingAgGrid,
      filter: 'agDateColumnFilter',
      filterParams: {
        suppressAndOrCondition: true,
        comparator: Helper.calendarAgGridComparator,
      },
      unSortIcon: true
    },
    { field: 'Source', minWidth: 130, headerName: 'SOURCE', headerTooltip: 'SOURCE', sortable: true, comparator: Helper.textSortingAgGrid,unSortIcon: true },
    { field: 'Status', minWidth: 130, headerName: 'STATUS', headerTooltip: 'STATUS', sortable: true, comparator: Helper.textSortingAgGrid,unSortIcon: true },
  ]);


  const excelStyles = useMemo(() => {
    return [
      {
        id: 'numberType',
        numberFormat: {
          format: '0',
        },
      },
      {
        id: 'negativeInBrackets',
        numberFormat: {
          format: '$[blue] #,##0;$ [red](#,##0)',
        },
      },
      {
        id: 'booleanType',
        dataType: 'Boolean',
      },
      {
        id: 'stringType',
        dataType: 'String',
      },
      {
        id: 'dateType',
        dataType: 'DateTime',
      },
    ];
  }, []);

  const popupParent = useMemo(() => {
    return document.body;
  }, []);

  const defaultColDef = useMemo(() => {
    return {
      flex: 1,
      sortable: true,
      filter: true,
      enableRowGroup: true,
      enableValue: true,
      width: 150,
      // minWidth: 130,
      resizable: true
      // suppressMovable: true,
      // menuTabs: ['filterMenuTab', 'columnsMenuTab'],
    };
  }, []);

  const onSelectionChanged = () => {
    setSelectionCount(gridRef?.current?.api?.getSelectedRows().length);
  }

  const fetchAPICall = async () => {
    __set('ACCOUNT_USER_API_CALL')
    await get_account_user_list(props.accountDetails)
    __remove('ACCOUNT_USER_API_CALL')

  };
  const onUnsponsorAcct = () => {
    if (gridRef.current.api.getSelectedRows().length > 0) {
      const list = gridRef.current.api.getSelectedRows();
      System.popup('UnsponsorUserAcct', { userId, list, base: 'accountDetails' })
    }
  }

  const onExportAll = async () => {
    __set('COMMON_API_CALL');
    $('#emailFilter').removeClass('open');
    if (isEdit)
      return false;
    __set('COMMON_API_CALL');
    if (totalAccountUser <= 2000) {
      const data = await export_account_user_list({ ...props.accountDetails, exportFileExtention: "xlsx" });
      Helper.downloadFileFromRes(data, 'account_user_list.xlsx');

      system_alert_indicator({
        name: "adminconsole",
        message: Constants.downloadMsg,
        type: "success",
        isDisplay: true,
      });

    } else {

      system_alert_indicator({
        name: "adminconsole",
        message: "File will be sent as an email attachment due to large number of records",
        type: "success",
        isDisplay: true,
      });
    }
    __remove('COMMON_API_CALL');
  }
  const exportGrid = async () => {
    $('#emailFilter').removeClass('open');
    __set('COMMON_API_CALL');
    if (agGridFiltered <= 2000) {
      const allColumnState = gridColumnApi.getColumnState();
      const customColumns = allColumnState.map((column) => column.colId);
      const params = { fileName: `account_user_list.xlsx`, sheetName: "Account", columnKeys: customColumns.slice(1) };
      await gridRef.current.api.exportDataAsExcel(params);
      system_alert_indicator({
        name: "adminconsole",
        message: Constants.downloadMsg,
        type: "success",
        isDisplay: true,
      });
    } else {
      system_alert_indicator({
        name: "adminconsole",
        message: "File will be sent as an email attachment due to large number of records",
        type: "success",
        isDisplay: true,
      });
    }
    __remove('COMMON_API_CALL');
  }
  const gridUpdateCallback = (event) => {
    setAgGridFiltered(event.api.getDisplayedRowCount());
  }
  const onColumnResided = (event) => {
    event.columnApi.getColumn('0').setActualWidth(50);
  }

  const onGridReady = (params) => {
    setAgGridFiltered(params.api.getDisplayedRowCount());
    params.api.addEventListener('filterChanged', gridUpdateCallback)
    params.api.addEventListener('filterModified', gridUpdateCallback)
    params.api.addEventListener('columnResized', onColumnResided);
    setGridColumnApi(params.columnApi);
  };

  useEffect(() => {
    if (selectedIndex < 0) {
      return;
    }
    const params = {
      accountNumber: accountDetail?.account_number,
      speedboat: System.avUserInfoData.speedBoatAbbr,
      salesOrg: accountDetail?.sales_org,
      userId: accountUserList[selectedIndex]?.user_id,
      roles: selectedRoles.map(v => v.roleName),
    }

    async function fetchHere() {
      const res = await update_user_roles(params);
      if (res.isSuccessFull) {

        system_alert_indicator({
          name: "adminconsole",
          message: res.data,
          type: "success",
          isDisplay: true,
        });

        setRefreshGrid(true);
      } else {
        system_alert_indicator({
          name: "adminconsole",
          message: res.message || res.errorMessage || "Error updating user roles",
          type: "danger",
          isDisplayIcon: true,
          isDisplay: false,
        });

      }
    }

    fetchHere();
    setIndex(-1)
  }, [selectedRoles]);

  return (
    <>
      {__check(['ACCOUNT_DETAIL_API_CALL', 'ACCOUNT_USER_API_CALL']).render}
      {!__check(['ACCOUNT_DETAIL_API_CALL', 'ACCOUNT_USER_API_CALL']).status &&
        <>
          <div className='w-100 d-flex align-items-center justify-content-between status-bar p-2'>
            <div className="d-flex justify-content-start">
              Filtered Line Count: <b>{agGridFiltered}</b>
            </div>
            <div className="d-flex justify-content-end">
              Total Records: <b>{totalAccountUser}</b>
            </div>
          </div>
          <div className='bg-black p-2 px-3'>
            <div className='d-flex align-items-center justify-content-between'>
              <div className='d-flex align-items-center'>
                <button disabled={isEdit} className={`bs5 btn btn-secondary ${selectionCount > 0 ? '' : ' disabled'}`}
                  onClick={() => onUnsponsorAcct()}><i className="fas5 fa-user-minus text-darkgreen me-2"
                    aria-hidden="true"></i>UNSPONSOR FROM AN ACCOUNT
                </button>
              </div>
              <div className='d-flex align-items-center'>
                {totalAccountUser > 0 && <span id="emailFilter" className="dropdown">
                  <a href={void (0)} data-toggle="dropdown" aria-expanded="false" className='text-white'>
                    <i className="fa fa-download me-1" aria-hidden="true"></i> Export List
                  </a>
                  <ul className="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton1">
                    <li><a href={void (0)} onClick={onExportAll}>Export All</a></li>
                    {rowData?.length > 0 && <li><a href={void (0)} onClick={exportGrid}>Export Filtered</a></li>}
                  </ul>
                </span>
                }
              </div>
            </div>
          </div>
          {rowData?.length > 0 ?
            <div className="ag-theme-alpine ag-grd-hg mb-5">
              <AgGridReact
                ref={gridRef}
                rowData={rowData}
                columnDefs={columnDefs}
                defaultColDef={defaultColDef}
                rowSelection={'multiple'}
                suppressRowClickSelection={true}
                onSelectionChanged={onSelectionChanged}
                isRowSelectable={isRowSelectable}
                onGridReady={onGridReady}
                excelStyles={excelStyles}
                popupParent={popupParent}
                autoGroupColumnDef={{
                  headerName: 'Group',
                  minWidth: 220,
                }}
              >
              </AgGridReact>
            </div> :
            <div>
              <NoResultContent message={'No User is associated to this account'} isDisplay={false} />
            </div>
          }
        </>
      }
      <RoleSelection />
    </>
  );
}
